import { CelebrationDropdown } from "@components/adapters/celebration/Dropdown";
import type { DropdownProps } from "@components/contracts/Dropdown.types";

export const Dropdown: React.FC<DropdownProps> = (props) => (
  <CelebrationDropdown {...props} />
);

export type { DropdownProps };
